import { BackendBaseModel } from '@/utils';
import { z } from 'zod';

import { ListBaseModel } from '@/api/models';

/**
 * 組織テンプレートモデル
 *
 * 事業の関連組織設定を効率化するためのテンプレート機能のデータモデル
 */
const OrganizationTemplateModel = BackendBaseModel.extend({
  name: z.string().min(1),
});

/**
 * 組織テンプレート一覧モデル（ページネーションなし）
 */
export const OrganizationTemplatesModel = OrganizationTemplateModel.array();

/**
 * 組織テンプレート詳細レスポンスモデル
 *
 * 利用組織とテンプレート組織の情報を含む
 */
export const OrganizationTemplateDetailModel = OrganizationTemplateModel.extend(
  {
    userOrganizationIds: z.string().uuid().array(),
    userOrganizations: z
      .object({
        organizationId: z.string().uuid(),
        organizationName: z.string(),
      })
      .array(),
    organizationIds: z.string().uuid().array(),
    organizations: z
      .object({
        organizationId: z.string().uuid(),
        organizationName: z.string(),
      })
      .array(),
  },
);

/**
 * 組織テンプレート一覧レスポンスモデル（ページネーション付き）
 */
export const OrganizationTemplatesWithPaginationModel = ListBaseModel.extend({
  results: OrganizationTemplateDetailModel.array(),
});

/**
 * 組織テンプレート作成/更新フォームスキーマ（Cascader用）
 *
 * Cascaderコンポーネントは階層構造を表すためstring[][]を返すため、
 * フォームではこの形式を使用する
 */
export const OrganizationTemplateFormSchema = z.object({
  name: z.string().min(1, '組織テンプレート名は必須です'),
  userOrganizationIds: z.string().uuid().array().array().min(1),
  organizationIds: z.string().uuid().array().min(1),
});

/**
 * 組織テンプレート作成APIリクエストスキーマ
 *
 * APIには最終的な組織IDのみを送信するため、string[]を使用する
 */
export const CreateOrganizationTemplateRequestSchema = z.object({
  name: z.string().min(1),
  userOrganizationIds: z.string().uuid().array(),
  organizationIds: z.string().uuid().array(),
});

/**
 * 組織テンプレート更新APIリクエストスキーマ
 */
export const UpdateOrganizationTemplateRequestSchema =
  CreateOrganizationTemplateRequestSchema.extend({
    id: z.string().uuid(),
  });

/**
 * 組織テンプレート検索フォームスキーマ
 *
 * テンプレート名、利用組織による絞り込みを行うための検索フォーム
 */
export const OrganizationTemplateSearchFormSchema = z.object({
  q: z.string().nullish(),
  nestedOrganizationIds: z.string().uuid().array().array(),
});
